import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { ReactComponent as PlayStoreIcon } from './image/play.svg';
import { ReactComponent as AppStoreIcon } from './image/apple.svg';
import IconButton from '@mui/material/IconButton';

function MobileAppCard({ title, icon, playLink, appSLink }) {
  return (
    <Card

    sx={{ minWidth: 150,

     }}>
      <CardContent sx={{ textAlign: 'center' }}>
        <img src={icon} style={{ width: '140px', height: '140px' }} alt="App Icon" />
        <Typography variant="h5" component="div" style={{ marginTop: '18px', marginBottom: '18px' }}>
          {title}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        <IconButton
          href={playLink}
          target="_blank"
          rel="noopener noreferrer"
          >
          <PlayStoreIcon style={{ width: 40, height: 40, marginLeft: 8, marginRight: 8 }} />
        </IconButton>
        <IconButton
          href={appSLink}
          target="_blank"
          rel="noopener noreferrer"
          >
          <AppStoreIcon style={{ width: 40, height: 40, marginLeft: 8, marginRight: 8 }} />
        </IconButton>
        </Box>
      </CardContent>
    </Card>
  );
}

export default MobileAppCard;
